export const APP_VERSION = "1.0.1";
export const VERSION_KEY = "helpgenie_app_version";

export const getStoredVersion = (): string | null => {
  return localStorage.getItem(VERSION_KEY);
};

export const setStoredVersion = (version: string): void => {
  localStorage.setItem(VERSION_KEY, version);
};

export const isVersionOutdated = (): boolean => {
  const storedVersion = getStoredVersion();
  return storedVersion !== null && storedVersion !== APP_VERSION;
};

export const isFirstVisit = (): boolean => {
  return getStoredVersion() === null;
};
